<template>
        <div class="wrapper">
          <details>
         <summary> 2023. 08. 15 ~  적용 (클릭)</summary> 
       <article class="title">
        <p>삼성전자는 사용자의 개인정보를 안전하게 보호하는 것을 가장 중요하게 생각합니다.</p>
        <p>삼성전자는 사용자가 신뢰할 수 있도록, 사용자가 제공한 개인정보를 목적에 따라 적법하게 사용하고, 제공한 개인정보에 대한 사용자의 권리와 선택을 보장하기 위해 최선을 다합니다. 이를 위해 제공된 개인정보가 어떤 목적으로 사용되고, 어떻게 보호되는지, 투명하게 공개합니다. 또한 사용자가 어떤 권리를 갖는지, 그 권리를 어떻게 행사할 수 있는지 자세히 알려드립니다.</p>
        </article>

        <table class="type-wide">
                <tbody>
                  <tr>
                    <th class colspan="3">주요 개인정보 처리 표시(라벨링)</th>
                  </tr>
                  <tr>
                    <td class>
                      개인정보 수집<br>
                      <img  src="../../../assets/label(img)/10.png" width="70" height="70"/><br>
                      IP,Timestamp 등 사용자가 본 서비스에 접속시 자동으로 생성되는 정보
                      </td>
                    <td class>
                      개인정보의 처리 목적<br>
                      <img  src="../../../assets/label(img)/24.png" width="70" height="70"/><br>
                      서비스 제공</td>
                    <td class> 
                      개인정보의 보유기간<br>
                      <img  src="../../../assets/label(img)/33.png" width="70" height="70"/><br>
                      회원 탈퇴시까지, 다른 법령에 따라 일정 기간 <br>개인정보를 보관해야 할 경우, 해당 기간 동안 보관 후 삭제 등</td>
                  </tr>
                  <tr>
                    <td class>
                      개인정보 처리위탁<br>
                      <img  src="../../../assets/label(img)/26.png" width="70" height="70"/><br>
                      위탁하지 않음
                      </td>
                    <td class> 
                      개인정보 제3자 제공<br>
                      <img  src="../../../assets/label(img)/22.png" width="70" height="70"/><br>
                      외부에 제공하지 않음
                      </td>
                    <td class> 
                      고충처리부서<br>
                      <img  src="../../../assets/label(img)/14.png" width="70" height="70"/><br>
                      부서명: 삼성전자 VD 사업부 디자인팀<br>
                      전화번호: 02-6147-5724<br>
                      이메일 주소: ssd.son@samsung.com
                      </td>
                  </tr>
                </tbody>
        </table>
        <br>
        <br>
        <ol class ="info-list">
            <h1>1. 개인정보 수집 항목 및 방법</h1>
            <br>
            <h2>(1) 개인정보 수집 항목</h2>
            <p>삼성전자는 사용자가 회원을 가입하거나 서비스를 이용할 때, 다음과 같은 개인정보를 수집합니다. 서비스 제공에 꼭 필요한 개인정보만 수집하며, 추가로 개인정보가 필요한 경우에는 별도의 선택 동의를 받은 후 수집합니다.</p>
             <table class="type-short">
                <tbody>
                  <tr>
                    <th class>구분</th>
                    <th class>자세한 내용</th>
                  </tr>
                  <tr>
                    <td class>기타 자동으로 생성/수집되는 개인정보</td>
                    <td class>-IP 주소, Timestamp</td>
                  </tr>
                </tbody>
              </table>
            <p style="color:blue">※ 삼성전자는 사용자의 사생활을 침해할 우려가 있는 민감정보(사상·신념, 노동조합·정당의 가입·탈퇴, 정치적 견해, 건강, 성생활 등에 관한 정보 등)는 수집하지 않습니다.</p>
            <p>※ 삼성전자는 만 14세 미만 사용자의 개인정보는 수집하지 않습니다. 단, 만 14세 미만 아동의 개인정보를 처리하기 위하여 개인정보보호법에 따른 동의를 받아야 할 때는 그 법정대리인에게 동의를 받고, 개인정보 사용이 끝나면 해당 정보를 바로 삭제하며, 개인정보가 사용되는 동안 개인정보를 안전하게 관리합니다.</p>
            <br>
            <h2>(2) 개인정보 수집 방법</h2>
            <p>삼성전자는 다음과 같이 개인정보를 수집합니다.</p>
            <p>∙ 서비스를 이용할 때 앱, 웹사이트 등에서 자동으로 생성된 정보(IP주소)를 수집</p>
            <br>
             <h1> 2. 개인정보 수집∙이용 목적  </h1>
             <p>삼성전자는 수집한 개인정보를 다음과 같이 사용합니다.</p>
              <table class="type-short">
                <tbody>
                  <tr>
                    <th class>목적</th>
                    <th class>자세한 내용</th>
                  </tr>
                  <tr>
                    <td class>서비스 제공</td>
                    <td class>웹 컨텐츠 제공을 위함</td>
                  </tr>
                </tbody>
              </table>
            <br>
            <h1> 3. 개인정보 제3자 제공 </h1>
            <p>삼성전자는 사용자의 동의 없이 개인정보를 외부에 제공하지 않습니다. 단, 다음의 경우는 예외입니다.</p>
            <p>∙ 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위해 불가피한 경우</p>
            <p>∙ 서비스 제공에 따른 요금 정산을 위해 필요한 경우</p>
            <p>∙ 재난, 감염병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급사항이 발행하는 경우</p>
            <br>
            
            <h1> 4.	개인정보 삭제 </h1>
            <p>삼성전자는 회원 탈퇴 등 개인정보 수집 및 이용이 끝나면 해당 정보를 바로 삭제합니다.</p>
            <p>단, 다음과 같이 다른 법령에 따라 일정 기간 개인정보를 보관해야 할 경우, 삼성전자는 해당 기간 동안 개인정보를 안전하게 보관한 후 삭제합니다.</p>
            <table class="type-wide">
                <tbody>
                  <tr>
                    <th class>보유 항목</th>
                    <th class>보유 기간</th>
                    <th class> 법적 근거</th>
                  </tr>
                  <tr>
                    <td class>계약 또는 청약철회 등에 관한 기록</td>
                    <td class>5년</td>
                    <td class> 전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>대금결제 및 재화 등의 공급에 관한 기록</td>
                    <td class> 5년</td>
                    <td class> 전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                    <td class> 3년</td>
                    <td class>전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                    <td class> 3년</td>
                    <td class> 신용정보의 이용 및 보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>표시/광고에 관한 기록</td>
                    <td class> 6개월</td>
                    <td class> 전자상거래 등에서의 소비자보호에 관한 법률</td>
                  </tr>
                  <tr>
                    <td class>사용자의 인터넷 등 로그 기록 / 사용자가 접속한 장소를 기록한 자료 </td>
                    <td class> 3개월</td>
                    <td class rowspan="2"> 통신비밀보호법</td>
                  </tr>
                   <tr>
                    <td class>그 외의 통신사실 확인 자료</td>
                    <td class> 12개월</td>
                  </tr>
                </tbody>
              </table>
              <h2>(1) 삭제 절차</h2>
              <p>사용자의 개인정보는 사용이 끝나면 바로 삭제됩니다. 위에서 언급한 것과 같이 개인정보를 보존해야 할 경우에는 별도의 데이터베이스(DB) 또는 다른 장소에 옮겨서 법정 기간 동안 보관하며, 기간이 지나면 바로 삭제합니다.</p>
              <br>
              <h2>(2) 삭제 방법 </h2>
              <p>삼성전자는 전자 파일 형태로 저장된 개인정보는 기록을 열어볼 수 없는 방법으로 삭제하며, 종이에 기재된 형태의 개인정보는 분쇄나 소각을 통해 삭제합니다.</p>
              <br>

              <h1>5. 사용자 및 법정대리인의 권리 및 행사 방법   </h1>
              <br>
              <p>삼성전자는 개인정보에 대한 사용자의 권리를 존중합니다. 사용자(만14세 미만인 경우에는 법정대리인)는 언제든지 개인정보 열람, 정정·삭제, 처리정지, 동의 철회를 삼성전자에 다음의 방법으로 요청할 수 있습니다. 단, 개인정보 보호법 등 관련 법령에 따라 일부 권리 행사가 제한될 수 있습니다.</p>
              <p>∙ 웹페이지/앱/서비스의 개인정보 설정 메뉴 이용</p>
              <p>∙ 삼성 개인정보 포털(https://privacy.samsung.com) 이용</p>
              <p>∙ 대표전화(1588-4730) 이용</p>
              <p>∙ 고객지원 담당부서 또는 개인정보 보호책임자에게 연락(다음 목차 참조)</p>
              <br>
              <h1>6. 고객지원 담당부서 및 개인정보 보호책임자    </h1>
              <br>
              <p>삼성전자는 사용자의 개인정보를 보호하고 개인정보와 관련된 불편사항을 개선하기 위해 고객지원 담당부서 및 개인정보 보호책임자를 지정하고 있습니다.</p>
              <p>사용자는 담당자에게 본인의 개인정보에 대한 권리 행사를 요청할 수 있으며, 삼성전자 서비스를 이용하며 발생한 개인정보 보호와 관련된 모든 민원을 신고할 수 있습니다. 삼성전자는 사용자의 신고사항에 대해 충분한 내용으로 신속하게 답변을 드릴 것입니다.</p>
              <br>
              <h2>(1) 고객지원 담당부서</h2>
              <p>∙ 고객지원 담당부서 : 삼성전자 VD사업부 디자인팀 FXD그룹</p>
              <p>∙ 전화 : 02-6147-5724</p>
              <p>∙ 문의처 : ssd.son@samsung.com</p>
              <br>
              <h2>(2) 개인정보 보호책임자 및 개인정보 보호 담당부서</h2>
              <p>∙ 개인정보 보호책임자 : 개인정보보호사무국장</p>
              <p>∙ 개인정보 보호 담당부서 : 개인정보보호사무국</p>
              <p>∙ 전화 : 1588-4730 </p>
              <p>∙ 문의처 : privacy.sec@samsung.com</p>
              <br>
              <p>(3) 기타 기관</p>
              <p>기타 개인정보 침해 신고나 상담이 필요한 경우에는 아래 기관에 문의해 주세요.</p>
              <br>
              <p>∙ 개인정보분쟁조정위원회 (www.kopico.go.kr / 국번없이 1833-6972)</p>
              <p>∙ 개인정보침해 신고센터 (privacy.kisa.or.kr / 국번 없이 118)</p>
              <p>∙ 대검찰청 사이버수사과 (www.spo.go.kr / 국번 없이 1301)</p>
              <p>∙ 경찰청 사이버수사국 (ecrm.cyber.go.kr / 국번 없이 182)</p>
              <br>
              <h1>7. 개인정보 자동 수집 장치의 설치, 운영, 거부에 관한 사항  </h1>
              <br>
              <p>삼성전자는 사용자의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’를 사용하지 않습니다.</p>
              <br>
              <h1>8. 안전한 개인정보 보호를 위한 조치  </h1>
              <p>삼성전자는 사용자의 개인정보를 안전하게 보호하기 위하여 다양한 보호조치와 노력을 하고 있습니다.</p>
              <br>
              <p>∙ 관리적 조치 : 내부 관리계획 수립 및 시행, 개인정보 교육 실시 등</p>
              <p>∙ 기술적 조치 : 개인정보에 대한 접근통제 장치 운영 및 접근 권한 제한, 개인정보 처리시스템 접속기록 보관 및 위조/변조를 방지하기 위한 보안기능 사용, 개인정보의 암호화, 백신 프로그램 및 보안 프로그램 설치 등</p>
              <p>∙ 물리적 조치 : 전산실, 자료보관실 등의 접근통제</p>
              <br>
              <h1>9. 개인정보 처리방침 업데이트  </h1>
              <p>개인정보 처리방침은 처리하는 개인정보 내용 등 변경사항이 있으면, 이를 반영하여 언제든지 업데이트될 수 있습니다. 이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다. 개인정보 처리방침이 업데이트될 경우, 시행되기 최소 7일 전에 공지사항 등을 통해 미리 알려드립니다.</p>
              <p>개인정보 처리방침 버전 번호 :  v 1.0</p>
              <p>개인정보 처리방침 시행 일자 :  2023년 08월 31일</p>




          </ol>
            </details>
        </div>
</template>

<script>


export default {
  components: {
  },
  data() {
    return {
     };
  },
  created() {


  },
  methods: {

  }
};
</script>

<style scoped>
details {
  display: block;
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
  margin-top:128px;
  text-align:left;
}
.wrapper {
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
}
/* .p{
  margin-block-start:1em;
  margin-block-end:1em;
} */
.hi{
  margin-top: 0px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
/* li{
  margin-top:4.453125vw;
} */
table{
  border-collapse:collapse;
  width:100%;
  text-align:center;
  margin-top:20px;
  margin-bottom:20px;
}
td,th{
  padding:0;
}
td,th{
  border: 1px solid #FFFFFF;
}
.info-item-0, .info-item-1,.info-item-2,.info-item-3,.info-item-4,.info-item-5,.info-item-6,.info-item-7,.info-item-8,.info-item-9,.info-item-10{
  margin-top:30px;
}
.info-item-2{
  margin-top:20px;
}
table.type-short{
  width:365px;
}
table.type-wide{
  width:920px;
}
ul,ol{
  list-style:none;
}
dl,ul,ol,dt,dd,blockquote,p,h1,h2,h3,h4,h5,h6{
  padding:0;
  margin:0;
  text-align:left;
}
tbody{
  display:table-row-group;
  vertical-align:middle;
}
@media (max-width: 1024px) {
  .wrapper{
    max-width: 83.33vw;
    margin:auto;
  }
  details {
  display: block;
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
  margin-top:70px;
  text-align:left;
}
img {
  width:30px;
  height:30px;
}
 .hi{
  margin-top: 0px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
table.type-wide{
  max-width: 83.33vw;
}
table.type-short{
  max-width: 83.33vw;
}
table{
  margin-top:10px;
  margin-bottom:10px;
}
}
</style>


    
    
   
   
   
    
   